import { LoadingSpinner } from "@jugl-web/ui-components/cross-platform";
import React from "react";

export const DefaultLoadingContent: React.FC = () => (
  <div className="flex items-center justify-center py-2">
    <LoadingSpinner />
  </div>
);
